<template>
  <div class="setting row">
    <form class="col-sm-4">
      <div class="form-group">
        <label for="exampleFormControlSelect2">نمایش پایه ها</label>
        <select
          multiple
          class="form-control"
          id="exampleFormControlSelect2"
          v-model="branchLableType"
          @change="updatePoleLabel"
        >
          <option value="0">بدون برچسب</option>
          <option value="1">نمایش تعداد انشعاب ها</option>
          <option value="2">نمایش برچسب</option>
        </select>
      </div>
    </form>

<form class="col-sm-4">
      <div class="form-group">
        <label for="exampleFormControlSelect2">نمایش  خطوط</label>
        <select
          multiple
          class="form-control"
          id="exampleFormControlSelect2"
          v-model="lineLableType"
          @change="updateLineLabel"
        >
          <option value="1">بدون برچسب</option>
          <option value="0">نمایش متراژ و مقطع</option>
        </select>
      </div>
    </form>

    <form class="col-sm-4">

    <div class="form-group">
        <label for="exampleFormControlSelect3">روش زوم</label>
        <select
          multiple
          class="form-control"
          id="exampleFormControlSelect3"
          v-model="zoomToType"
          @change="updateZoomToType"
        >
          <option value="0">روی کل فیدر</option>
          <option value="1">مقدار مشخص</option>
          <!-- <option value="2">نمایش برچسب</option> -->
        </select>
      </div>
    </form>
    <!-- <input v-model="myNum" @change="saveMyName" /> -->
  </div>
</template>
<script>
// import '../app/tools/StorageTls';
// import {Lockr} from 'Lockr';
// import * as Lockr from 'lockr';
export default {
  name: "Setting",
  data() {
    return {
      myNum: 0,
      branchLableType: "",
      lineLableType: "",
    
      zoomToType: 0 ,
    };
  },
  mounted() {
    var Lockr = require("lockr");
    this.myNum = Lockr.get("myNum", 1);
    this.branchLableType = Lockr.get("branchLableType", 1);
    this.lineLableType = Lockr.get("lineLableType", 0);

    this.zoomToType = Lockr.get("zoomToType", 1);

  },
  methods: {
    saveMyName() {
      var Lockr = require("lockr");
      Lockr.set("myNum", this.myNum);
    },
    updatePoleLabel() {
      var Lockr = require("lockr");
      Lockr.set("branchLableType", this.branchLableType);
    },
    updateLineLabel() {
      var Lockr = require("lockr");
      Lockr.set("lineLableType", this.lineLableType);
    },
        updateZoomToType() {
      var Lockr = require("lockr");
      Lockr.set("zoomToType", this.zoomToType);
    },
  },
};
</script>

<style scoped>
</style>
